import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Real-time listener for a specific form configuration document.
 * Reads from forms/{formId} in Firestore.
 */
export function useFormConfig(formId) {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!formId) return;
        
        const unsubscribe = onSnapshot(
            doc(db, "forms", formId),
            (snapshot) => {
                if (snapshot.exists()) {
                    setConfig({ id: snapshot.id, ...snapshot.data() });
                } else {
                    setError("Nie znaleziono formularza.");
                }
                setLoading(false);
            },
            (err) => {
                console.error("Error listening to form config:", err);
                setError(err.message);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [formId]);

    return { config, loading, error };
}
